// Schutz gegen Abstürze durch die automatische Übersetzung (Google Übersetzer).
// Der Übersetzer tauscht Textknoten im DOM aus; React findet danach seine Knoten nicht mehr
// und removeChild/insertBefore werfen NotFoundError -> weisse Seite. Bekanntes Vorgehen aus der
// React-Diskussion zu Google Translate: die beiden Aufrufe tolerant machen, statt die
// Übersetzung zu sperren (Mitarbeiterinnen mit anderer Muttersprache brauchen sie).
// Ohne Importe und ohne React, damit die Datei per Node testbar ist.
export const installiereDomSchutz = (proto) => {
  if (!proto || typeof proto.removeChild !== 'function' || typeof proto.insertBefore !== 'function') return;
  if (proto.__domSchutzAktiv) return;

  let gewarnt = false;
  const warnen = () => {
    if (gewarnt) return;
    gewarnt = true;
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('DOM durch Übersetzung verändert – abgefangen');
    }
  };

  const originalRemoveChild = proto.removeChild;
  const originalInsertBefore = proto.insertBefore;

  proto.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      warnen();
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  proto.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      warnen();
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };

  proto.__domSchutzAktiv = true;
};
